import Link from 'next/link';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '@/constants/common';

import * as S from './TermsLink.styles';

export const TermsLink: FC = () => {
  const { t } = useTranslation();
  return (
    <S.AgreementText>
      {t('Advertise.payment_disclaimer_parts.prefix')}{' '}
      <S.AgreementLink
        as={Link}
        rel="noopener noreferrer"
        target="_blank"
        href={ROUTES.TERMS_AND_CONDITIONS}
      >
        {t('Advertise.terms_label')}
      </S.AgreementLink>{' '}
      {t('Advertise.payment_disclaimer_parts.suffix')}
    </S.AgreementText>
  );
};
